var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3286 14.1718L13.3824 8.4382C13.2616 8.32171 13.1337 8.23811 12.9987 8.1874C12.8637 8.13668 12.7197 8.11133 12.5667 8.11133C12.4136 8.11133 12.2696 8.13668 12.1346 8.1874C11.9997 8.23811 11.8718 8.32171 11.751 8.4382L5.78428 14.1916C5.5583 14.4095 5.44531 14.675 5.44531 14.988C5.44531 15.3011 5.5583 15.5665 5.78428 15.7845C6.01027 16.0024 6.28901 16.108 6.6205 16.1014C6.95197 16.0948 7.2307 15.9826 7.4567 15.7647L12.5667 10.8374L17.6971 15.7845C17.9231 16.0024 18.195 16.1113 18.5129 16.1113C18.8307 16.1113 19.1026 16.0024 19.3286 15.7845C19.5545 15.5665 19.6675 15.2978 19.6675 14.9781C19.6675 14.6585 19.5545 14.3897 19.3286 14.1718Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.1293343e.svg";
export { ForwardRef as ReactComponent };